import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { GENERIC_FILE_CONTROL_DEPENDS, GenericFileControlDirective } from '../directive';
import { PreviewFileComponent } from '../component';
import { CommonModule, KeyValuePipe, NgForOf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ControlComponent } from '@portal/upload-file/control';
import { ReactiveFormsModule } from '@angular/forms';
import { CyTestDirective } from '@portal/directive';

@Component({
  selector: 'portal-form-file',
  standalone: true,
  imports: [
    ...GENERIC_FILE_CONTROL_DEPENDS,
    PreviewFileComponent,
    NgForOf,
    KeyValuePipe,
    MatIconModule,
    ControlComponent,
    ReactiveFormsModule,
    FormlyModule,
    CyTestDirective,
    CommonModule,
  ],
  template: `
    <ng-container *ngFor="let kv of control.value | keyvalue">
      <portal-form-preview-file
        [isDisabled]="this.disabled"
        [fileModel]="kv.value"
        (remove)="removeFile($event)"
      ></portal-form-preview-file>
    </ng-container>

    <div
      *ngIf="this.disabled && !control.value?.size"
      class="field-value"
    >
      -
    </div>

    <label
      *ngIf="!this.disabled"
      [tabIndex]="props.tabindex"
      class="field-file-wrapper"
      [class.field-invalid]="showError"
      [portalCyTest]="field.key"
    >
      <span class="flex items-center justify-center">
        <mat-icon class="field-file-prefix">add_circle_outline</mat-icon>
      </span>
      <span class="break-words">Tap here to upload another file</span>

      <portal-upload-file-control
        [name]="field.name"
        [id]="id"
        [multiple]="props.multiple"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [acceptMineTypes]="acceptMimeTypes"
      ></portal-upload-file-control>
    </label>
  `,
  styles: [':host {display: block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileComponent extends GenericFileControlDirective {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'file',
          component: FileComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
})
export class FormFileModule {}
